"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OKXTonProvider = void 0;
const _1 = require("./");
const core_1 = require("@okxconnect/core");
class OKXTonProvider {
    constructor(generator) {
        this.statusChangeSubscriptions = [];
        this.statusChangeErrorSubscriptions = [];
        this.provider = generator;
        this.provider.on("connect", () => {
            let tonWallet = this.wallet();
            (0, core_1.logDebug)("OKXTONProvider event connect:", JSON.stringify(tonWallet));
            this.statusChangeSubscriptions.forEach(callback => callback(tonWallet));
        });
        this.provider.on("reconnect", () => {
            let tonWallet = this.wallet();
            (0, core_1.logDebug)("OKXTONProvider event reconnect:", JSON.stringify(tonWallet));
            this.statusChangeSubscriptions.forEach(callback => callback(tonWallet));
        });
        this.provider.on("disconnect", () => {
            (0, core_1.logDebug)("OKXTONProvider event disconnect:");
            this.statusChangeSubscriptions.forEach(callback => callback(null));
        });
        this.provider.on("connect_error", (error) => {
            (0, core_1.logDebug)("OKXTONProvider event connect_error:", JSON.stringify(error));
            this.statusChangeErrorSubscriptions.forEach(errorsHandler => errorsHandler(error));
        });
    }
    connected() {
        if (this.provider.connected()) {
            return !!this.provider.session.namespaces["ton"];
        }
        return false;
    }
    account() {
        try {
            if (!this.provider.session) {
                return null;
            }
            let tonNameSpace = this.provider.session.namespaces['ton'];
            if (!tonNameSpace || !tonNameSpace.payload || !tonNameSpace.payload.ton_addr) {
                return null;
            }
            let ton_addr = tonNameSpace.payload.ton_addr;
            return {
                address: ton_addr.address,
                chain: ton_addr.network,
                walletStateInit: ton_addr.walletStateInit,
                publicKey: ton_addr.publicKey,
            };
        }
        catch (e) {
            (0, core_1.logDebug)("OKXTONProvider account  error:", JSON.stringify(e));
            return null;
        }
    }
    wallet() {
        if (this.connected()) {
            try {
                let sessionWallet = this.provider.session.wallet;
                let tonDeviceInfo = {
                    platform: sessionWallet.platform,
                    appName: sessionWallet.appName,
                    appVersion: sessionWallet.appVersion,
                    maxProtocolVersion: sessionWallet.maxProtocolVersion,
                    features: ['ton_sendTransaction'],
                };
                const wallet = {
                    device: tonDeviceInfo,
                    provider: "http",
                    account: this.account()
                };
                let tonNameSpace = this.provider.session.namespaces['ton'];
                if (tonNameSpace && tonNameSpace.payload && tonNameSpace.payload.ton_proof) {
                    wallet.connectItems = {
                        tonProof: tonNameSpace.payload.ton_proof
                    };
                }
                (0, core_1.logDebug)("OKXTONProvider wallet :", JSON.stringify(wallet));
                return wallet;
            }
            catch (e) {
                (0, core_1.logDebug)("OKXTONProvider wallet  error:", JSON.stringify(e));
                return null;
            }
        }
        return null;
    }
    onStatusChange(callback, errorsHandler) {
        this.statusChangeSubscriptions.push(callback);
        if (errorsHandler) {
            this.statusChangeErrorSubscriptions.push(errorsHandler);
        }
        return () => {
            this.statusChangeSubscriptions = this.statusChangeSubscriptions.filter(item => item !== callback);
            if (errorsHandler) {
                this.statusChangeErrorSubscriptions = this.statusChangeErrorSubscriptions.filter(item => item !== errorsHandler);
            }
        };
    }
    sendTransaction(transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            if (transaction.network && transaction.network !== core_1.TONCHAIN.MAINNET) {
                throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, 'OKXTONProvider sendTransaction network error');
            }
            if (!transaction.network) {
                transaction.network = core_1.TONCHAIN.MAINNET;
            }
            if (this.provider.session) {
                if (!transaction.from) {
                    const accounts = this.provider.requestAccountsWithNamespace('ton');
                    transaction.from = accounts[0];
                }
            }
            const requestParams = {
                method: "ton_sendTransaction",
                params: transaction,
            };
            let chain = 'ton:' + core_1.TONCHAIN.MAINNET;
            (0, core_1.logDebug)("OKXTONProvider sendTransaction transaction----:", chain, JSON.stringify(requestParams));
            return this.provider.request(requestParams, chain);
        });
    }
}
exports.OKXTonProvider = OKXTonProvider;
exports.default = OKXTonProvider;
